import { apiGadgets } from './apiGadgets'
import { apiGadgetsMedia } from './apiGadgetsMedia'
import { apiGadgetsProducts } from './apiGadgetsProducts'
import { apiGadgetsOrders } from './apiGadgetsOrders'
import { apiGadgetsProductVariants } from './apiGadgetsProductVariants'
import { apiGadgetsWarehouse } from './apiGadgetsWarehouse'
import { apiGadgetsWarehouseStatuses } from './apiGadgetsWarehouseStatuses'

const GADGETS_WAREHOUSE_QUERY_KEY = 'gadgets-warehouse-query' as const
export const gadgetsWarehouseQueryKey = { ...useQueryKeyFactory(GADGETS_WAREHOUSE_QUERY_KEY) }

const apiGadgetsGroup = {
	...apiGadgets,
	...apiGadgetsMedia,
	...apiGadgetsProducts,
	...apiGadgetsOrders,
	...apiGadgetsProductVariants,
	...apiGadgetsWarehouse,
	...apiGadgetsWarehouseStatuses,
}

export { apiGadgetsGroup }
